import { SearchState } from '../../../models';
import { RootStoreState } from '../../store.interfaces';
import { SEARCH_GETTERS_KEYS } from '../search.const';
import { SearchGetter } from '../search.interfaces';

export class SearchBoxSuggestionGetter implements SearchGetter {

  getters = {
    [SEARCH_GETTERS_KEYS.searchBoxSuggestion]: (searchState: SearchState, searchGetters: any,
      { empathize: { termSuggestions }, core: { inputQuery } }: RootStoreState): string => {
      const autoCompleteSuggestion = termSuggestions.find(suggestion =>
        suggestion.term.toLowerCase().startsWith(inputQuery.toLocaleLowerCase()) && suggestion.term.length !== inputQuery.length);

      if (autoCompleteSuggestion) {
        return autoCompleteSuggestion.term.replace(new RegExp(inputQuery, 'i'), inputQuery);
      }
      return '';
    }
  };
}
